import React from "react";
import { Navbar } from "react-bootstrap";
import { useLocation } from "react-router-dom";

import { AccountMenu } from "./AccountMenu";
import CDK_GLOBAL_LOGO from "../../images/CDKGlobalWM_BLK.jpg";
import "../../styles/styles.css";

export const CDKHeader = () => {
  let location = useLocation();

  const { pathname } = location;
  const isNonSEZFormPage = !(
    pathname === "/SEZForm" || pathname === "/LeaveAndGratuityForm"
  );

  const isLoginPagesLoaded = [
    "/",
    "/ForgotPassword",
    "/ChangePassword"
  ].includes(pathname);

  return (
    <Navbar
      className={`cdk-ta-header-main${
        isLoginPagesLoaded ? " login-pages-header" : ""
      }`}
      variant="dark"
      fixed="top"
    >
      <Navbar.Brand className="d-flex align-items-center">
        <img className="cdk-logo" src={CDK_GLOBAL_LOGO} alt="CDKGlobalWM_WHT" />
        {isNonSEZFormPage && (
          <span className="ml-3 title">Talent Acquisition </span>
        )}
      </Navbar.Brand>

      {isNonSEZFormPage && <AccountMenu />}
    </Navbar>
  );
};
export default CDKHeader;
